import React from 'react';
import { AspectRatio } from '../types';
import { ASPECT_RATIOS, AUDIENCES, PLATFORMS, STORY_DESCRIPTION_MAX } from '../constants';

export interface StoryTabProps {
  description: string;
  onDescriptionChange: (value: string) => void;
  aspectRatio: AspectRatio;
  onAspectRatioChange: (ratio: AspectRatio) => void;
  platform: string;
  onPlatformChange: (value: string) => void;
  audience: string;
  onAudienceChange: (value: string) => void;
  slideCount: number;
}

const StoryTab: React.FC<StoryTabProps> = ({
  description,
  onDescriptionChange,
  aspectRatio,
  onAspectRatioChange,
  platform,
  onPlatformChange,
  audience,
  onAudienceChange,
  slideCount,
}) => (
  <>
    <div className="se-field">
      <label className="se-label">Description</label>
      <textarea
        className="se-textarea"
        placeholder="What this Story is about — used as the video description when it is published."
        value={description}
        onChange={e => onDescriptionChange(e.target.value.slice(0, STORY_DESCRIPTION_MAX))}
        rows={4}
      />
      <span className="se-charcount">{description.length}/{STORY_DESCRIPTION_MAX}</span>
    </div>

    <div className="se-field">
      <label className="se-label">Aspect Ratio</label>
      <div className="se-aspect-ratio-grid">
        {ASPECT_RATIOS.map(ar => (
          <button
            key={ar.value}
            className={`se-aspect-btn ${aspectRatio === ar.value ? 'se-aspect-active' : ''}`}
            onClick={() => onAspectRatioChange(ar.value)}
            title={ar.label}
          >
            <span className="se-aspect-label">{ar.label}</span>
          </button>
        ))}
      </div>
      <div className="se-help-text">
        ℹ️ Aspect ratio applies to all {slideCount} slide{slideCount !== 1 ? 's' : ''} in this Story
      </div>
    </div>

    <div className="se-field">
      <label className="se-label">Platform</label>
      <select className="se-select" value={platform} onChange={e => onPlatformChange(e.target.value)}>
        {PLATFORMS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
      </select>
    </div>

    <div className="se-field">
      <label className="se-label">Audience</label>
      <select className="se-select" value={audience} onChange={e => onAudienceChange(e.target.value)}>
        {AUDIENCES.map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
      </select>
      <div className="se-help-text">
        ℹ️ Platform and audience are seeded from the project and owned by this Story once set
      </div>
    </div>
  </>
);

export default StoryTab;
